import React from "react";
import { Play } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Card, CardContent } from "@/components/ui/card";
import SectionContainer from "@/components/common/SectionContainer";
export default function YurtExperienceVideoGrid() {
  const amenities = ["AC / Heat", "Private bathroom with shower, towels, soap etc.", "Fully shaded picnic area", "Queen bed with linens, blankets and pillows", "Full size sofa sleeper with linens, blankets and pillows", "Twin cots with sleeping bags and pillows", "Mini refrigerator with freezer", "Dining table", "Variety of games (monopoly, dominoes, corn hole etc.)", "Fishing, swimming, etc."];
  return;
}